import { useRouteLoaderData } from 'react-router';

export const useIsProductionEnv = () => {
  const { clientEnv } = useRouteLoaderData('root') || {};

  return clientEnv === 'production';
};
